import { Message } from "@core/models/message.model";
import { TPagination } from "@custom-types/sorting";
import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromMessage from "./message.reducers";

export const SELECT_MESSAGE_STATE =
  createFeatureSelector<fromMessage.MessageState>(
    fromMessage.MESSAGES_FEATURE_KEY
  );

export const SELECT_MESSAGE_LIST = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): Array<Message> => state.messages
);

export const SELECT_MESSAGE_LOADING_STATUS = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): boolean => state.loading
);

export const SELECT_MESSAGE_LIST_LENGTH = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): number => state.messagesLength
);

export const SELECT_MESSAGE_PAGINATION = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): Partial<TPagination> | undefined =>
    state.pagination
);
